// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1lHcG","name":"Header_name__2u5KK","birthday":"Header_birthday__3zAhk","skeleton":"Header_skeleton__1Fl_o"};